import { render, staticRenderFns } from "./EmpresasParceiros.vue?vue&type=template&id=542955d2&scoped=true&"
import script from "./EmpresasParceiros.vue?vue&type=script&lang=js&"
export * from "./EmpresasParceiros.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "542955d2",
  null
  
)

export default component.exports